import { ControllerContract } from '../architecture/ControllerContract';
import { createCustomerSession } from '../models/customer-session/CreateCustomerSession';

export const customerSessionRoutes = {
    controllerPath: 'customer-session',
    endpoints: {
        createCustomerSession
    }
} as const satisfies ControllerContract;

export type CustomerSessionRoutes = typeof customerSessionRoutes;
